// ─────────────────────────────────────────────────────────────
//  Özel Takvimim — Cycle Service
//  Tüm istekler JWT auth ile gider — aile izolasyonu yoktur
//  çünkü cycle verileri tamamen kişiseldir.
// ─────────────────────────────────────────────────────────────
import { apiRequest, ensureAccessToken } from "./apiClient";

// ── Settings ─────────────────────────────────────────────────
export async function getCycleSettings() {
  return apiRequest("/cycle/settings");
}

export async function saveCycleSettings(settings) {
  return apiRequest("/cycle/settings", {
    method: "PUT",
    body: JSON.stringify(settings),
  });
}

// ── Predictions ──────────────────────────────────────────────
export async function getCyclePredictions() {
  return apiRequest("/cycle/predictions");
}

// ── Periods ──────────────────────────────────────────────────
export async function getCyclePeriods(months = 24) {
  return apiRequest(`/cycle/periods?months=${months}`);
}

export async function startPeriod({ start_date, end_date = null, flow_intensity = "normal", notes }) {
  return apiRequest("/cycle/periods", {
    method: "POST",
    body: JSON.stringify({ start_date, end_date, flow_intensity, notes }),
  });
}

export async function endPeriod(end_date) {
  return apiRequest("/cycle/periods", {
    method: "POST",
    body: JSON.stringify({ action: "end", end_date }),
  });
}

export async function deletePeriod(id) {
  return apiRequest(`/cycle/periods/${id}`, { method: "DELETE" });
}

// ── Daily Entries ─────────────────────────────────────────────
export async function getDayEntry(date) {
  return apiRequest(`/cycle/entries/${date}`);
}

export async function saveDayEntry(date, data) {
  return apiRequest(`/cycle/entries/${date}`, {
    method: "POST",
    body: JSON.stringify(data),
  });
}

// ── Calendar ──────────────────────────────────────────────────
export async function getCalendarMonth(year, month) {
  return apiRequest(`/cycle/calendar/${year}/${month}`);
}

// ── Analysis ─────────────────────────────────────────────────
export async function getCycleAnalysis(range = "6m") {
  return apiRequest(`/cycle/analysis?range=${range}`);
}

// ── Insights ─────────────────────────────────────────────────
export async function getCycleInsights(lang = "tr") {
  return apiRequest(`/cycle/insights?lang=${lang}`);
}

// ── Medications ───────────────────────────────────────────────
export async function getCycleMedications() {
  return apiRequest("/cycle/medications");
}

export async function addCycleMedication(data) {
  return apiRequest("/cycle/medications", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function updateCycleMedication(id, data) {
  return apiRequest(`/cycle/medications/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function deleteCycleMedication(id) {
  return apiRequest(`/cycle/medications/${id}`, { method: "DELETE" });
}

// ── Export ────────────────────────────────────────────────────
export async function exportCycleData(format = "json") {
  const API_BASE = (
    process.env.REACT_APP_API_BASE_URL || "https://api.aileyonetimi.com"
  ).replace(/\/+$/, "");
  const token = await ensureAccessToken({ source: "cycle_export" });
  const res = await fetch(`${API_BASE}/cycle/export?format=${format}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res;
}

// ── Delete Data ───────────────────────────────────────────────
export async function deleteCycleData({ scope, date, month }) {
  const params = new URLSearchParams({ scope });
  if (date) params.set("date", date);
  if (month) params.set("month", month);
  return apiRequest(`/cycle/data?${params}`, { method: "DELETE" });
}
